import styled from 'styled-components';
import { rem } from 'polished';

export const CrossSellingCards = styled.div`
  [data-component-name='Accordion'] {
    margin-bottom: 30px;
  }
`;
export const CrossSellingContentWrapper = styled.div`
  [class*='CollapsibleContainerHeaderstyle__Children-sc-1vo9eu6-1'] {
    display: flex;
    justify-content: space-between;
    align-items: stretch; // Change to stretch for equal height
    flex-direction: column;
    font-size: ${rem('20px')};
    font-weight: 700;

    h2 {
      font-weight: 700;
      margin: 0;
    }

    span {
      font-size: ${rem('20px')};
      font-weight: 700;
    }

    #priceText {
      align-self: stretch;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-top: ${rem('16px')};
      margin-bottom: ${rem('16px')};
    }

    [data-component-name='Button'] {
      align-self: stretch;
      display: flex;
      align-items: center;
      width: ${rem('152px')};
      font-size: ${rem('16px')};
    }

    @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
      flex-direction: row;
      align-items: center; // Center items vertically

      span {
        font-size: ${rem('28px')};
      }

      #priceText {
        margin-left: 0;
        min-height: auto;
        align-self: center;
        width: ${rem('180px')};
      }

      [data-component-name='Button'] {
        margin-right: ${rem('20px')};
        min-height: auto;
        align-self: center;
      }
    }
  }
`;

export const CrossSellingContent = styled.div`
  display: flex;
  gap: ${rem('10px')};
  flex: 0.5;
  min-height: ${rem('80px')};
  align-items: center;
`;

export const CrossSellingImageWrapper = styled.div`
  width: 50px;
  height: 50px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;
